import React from "react";
import { useCloud } from "./CloudProvider.js";
import { List } from "../../../packages/ui/list/List.js";
import { CloudEntryItem } from "./CloudEntryItem.js";
import { Alert } from "../../../packages/ui/Alert.js";

/**
 * Displays the list of cloud files and directories.
 */
export const CloudEntriesList = () => {
  const { entries } = useCloud();

  if (entries.length === 0) {
    return <Alert type="info">This directory is empty.</Alert>;
  }

  return (
    <List>
      {entries.map((entry) => (
        <CloudEntryItem key={entry.name} entry={entry} />
      ))}
    </List>
  );
};
